export default {
  featuredArticlesTitle: {
    id: 'product_comparison_buying_guides_title',
    defaultMessage: 'Our featured articles',
  },
  relatedComparePagesTitle: {
    id: 'product_comparison_cross_links_title',
    defaultMessage: 'Our recent comparisons',
  },
}
